class VwHbsArsivtanimDTO {
    pkArsivtanim: number = 0;
    fkArsivdepo?: number = null;
    fkHastaRaporId?: number = null;
    adi?: string = "";
    aktif?: string = "E";
    treeKey?: string = "";
    parentKey?: string = "";
    fkUstId?: number = null;
    aciklama?: string = "";
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    eklemeIpadres?: string = "";
    iptal?: string = "H";
    fkIptalneden?: number = null;
    iptaltarih?: string = null;
    fkIptalkullanici?: number = null;
    hastaAdi?: string = "";
    hastaSoyadi?: string = "";
    hastaDogumTarihi?: string = null;
    servisAdi?: string = "";
    protokolNo?: number = null;
    protokolOnek?: string = "";
    protokolYil?: number = null;
    islemAdi?: string = "";
    doktorAdi?: string = "";
    asistanAdi?: string = "";
}
export default VwHbsArsivtanimDTO;